"use strict";
/**
 * @module Candidates
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCandidateSummary = void 0;
var getCandidateSummary_1 = require("./getCandidateSummary");
Object.defineProperty(exports, "getCandidateSummary", { enumerable: true, get: function () { return getCandidateSummary_1.getCandidateSummary; } });
